import { Center, Spinner } from '@chakra-ui/react';
import { useReducedMotion } from 'framer-motion';
import React from 'react';
import { MotionBox } from '../../motion/MotionComponents';

interface PageLoaderProps {
  height?: string;
}

const PageLoader: React.FC<PageLoaderProps> = ({ height = '100vh' }) => {
  const prefersReducedMotion = useReducedMotion();

  return (
    <Center height={height}>
      <MotionBox
        initial={
          prefersReducedMotion
            ? { opacity: 1, scale: 1 }
            : { opacity: 0, scale: 0.98 }
        }
        animate={{ opacity: 1, scale: 1 }}
      >
        <Spinner
          size="xl"
          color="blue.500"
        />
      </MotionBox>
    </Center>
  );
};

export default PageLoader;
